module.exports = __webpack_public_path__ + "media/images/front/img_movie_feature04-67859216cc3f6f081751cbbac501f181.jpg";